import { SurveyQuestions } from "modules/NewClientSurvey/common/interface"

export const CARDS = [
    {
        urL: "/api/survey/family",
        is_primary: false,
        title: "Мне и партнеру или семье",
        subtitle: "Парная и семейная терапия",
        image: "family-session.svg",
    },
    {
        urL: "/api/survey/individual",
        is_primary: true,
        title: "Только мне",
        subtitle: "Индивидуальная терапия",
        image: "one-person-session.svg",
    },
    {
        urL: "/api/survey/child",
        is_primary: false,
        title: "Ребенку или подростку",
        subtitle: "Психотерапия для детей и подростков",
        image: "child-session.png",
    },
]

export const FAMILY_QUESTIONS = {
    title: "Семейная анкета",
    subtitle: "",
    image: null,
    slug: "family",
    is_primary: false,
    questions: [
        {
            id: "cc733c92-6853-45f6-8e49-bec741188ebb",
            ref: "accompaniment",
            title: "С кем вы планируете прийти на сессию?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 1,
            choices: [
                {
                    id: "a41f020c-2d4d-433f-b1d3-979f1043fae0",
                    title: "С партнером/партнерами",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "aca531ae-e7ba-40c3-9d0c-fbfb5d8ca6c2",
                    title: "С другими членами семьи",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "9626bf79-2f97-4c0c-9aae-de080adab7df",
                    title: "Всей семьей",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "69261bc2-4a71-4de7-bc8b-1beb0d9320ac",
            ref: "has_been_before",
            title: "Вы впервые обращаетесь к психологу?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 2,
            choices: [
                {
                    id: "a82c1e87-66b2-44a6-bb4b-76449a53270c",
                    title: "Да",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "7217d7d2-6f24-4bf5-942d-3e4cf15982c1",
                    title: "Нет",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "01b96a66-733e-47fa-abbd-3011ea911cb2",
            ref: "sex",
            title: "Какого вы пола?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 3,
            choices: [
                {
                    id: "7019f6a5-2771-4971-8825-bdd51d2a12b3",
                    title: "Женского",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "a5e24f10-dae7-4e5b-bfe0-23f83bf83840",
                    title: "Мужского",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "a03345ac-96b3-4bbe-bc2d-be2943446578",
                    title: "Не хочу отвечать",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "566d8687-8fb6-45c2-b5f8-2486d147bcd2",
            ref: "age",
            title: "Сколько вам лет?",
            type: "number",
            required: false,
            validations: {
                max_value: 100,
                min_value: 18,
            },
            step: 1,
            sequence_number: 4,
            choices: [],
            visibility_conditions: [],
        },
        {
            id: "d9117f52-3839-4641-a470-7de16f437d8b",
            ref: "reported_problems",
            title: "Над чем вы хотите поработать?",
            type: "choices",
            required: true,
            validations: {},
            step: 2,
            sequence_number: 5,
            choices: [
                {
                    id: "4bd92013-31c5-4f87-b9c5-7148993aea1c",
                    title: "У нас много конфликтов",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "59a7546d-ca9f-46c9-a033-bb9d3bf2b86f",
                    title: "Мы отдалились друг от друга",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "11804b64-1b8c-4606-a3eb-8ba56cadfe2c",
                    title: "Я не уверен, что люблю партнера",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "9e65861e-41bf-4b1e-95eb-ea32c7815ad2",
                    title: "Хочу понять, как строить отношения дальше",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "3e845e46-5804-4f4b-b1c3-296931fb5bd1",
                    title: "В отношениях произошла измена",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "4eb8bd82-bb8b-4132-9086-a9edafd8f8eb",
                    title: "Мы хотим усыновить ребенка",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "af90e67e-73f0-49ef-aec3-5b986527fe9d",
                    title: "Мы расстались, нам трудно экологично завершить",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "b3dd6ebb-a857-483d-bf09-418e5f8dc9e8",
            ref: "psychiatry",
            title: "Наблюдаетесь ли вы у психиатра?",
            type: "choice",
            required: true,
            validations: {},
            step: 2,
            sequence_number: 6,
            choices: [
                {
                    id: "4c91aba0-1c11-4824-98a0-c64e6f409bce",
                    title: "Да",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "8f17ffe7-f91c-4b7f-bb8d-192fe68f5692",
                    title: "Нет",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "d2cc542f-173c-43f2-8115-0137188ce7ab",
                    title: "Наблюдалась раньше",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "4f058a54-a084-450f-9cd4-34acffcecb26",
            ref: "form_of_work",
            title: "Как вы хотите работать с психологом?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 7,
            choices: [
                {
                    id: "c185d6f0-33d3-462d-8fd7-40e30b315ed3",
                    title: "Только онлайн",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "93646898-875e-4073-91d1-e300449536f5",
                    title: "Только лично",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "6c3c5f37-8cb9-4b80-a50e-55ac0d6f913f",
                    title: "Не принципиально",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "31967b1d-1af8-4318-8733-6ad9575e207b",
            ref: "city",
            title: "В каком городе вам нужен психолог?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 8,
            choices: [
                {
                    id: "b51906d5-ebc7-46e2-a36f-be6f30f5a571",
                    title: "Москва",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "10d44ccd-cd8d-4edf-8711-174b8a2bc3f5",
                    title: "Питер",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "96bacd34-d5e1-41f0-ab7b-e997155da3aa",
                    title: "Другой",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "f25e1c8d-e018-4e9c-8e3d-77f9bd8af66b",
            ref: "daytime",
            title: "Когда вам удобно проводить сессии?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 9,
            choices: [
                {
                    id: "dc4d0b5a-6bef-4141-b28b-70c2ce62c7bb",
                    title: "Утром",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "eac4e114-cb83-4542-955b-b3a0d83ad014",
                    title: "Днем",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "9ca1ec8d-2bb6-4184-99d8-ddee8f6cb510",
                    title: "Вечером",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "0f54b716-e655-4939-bb26-093fcff482d2",
                    title: "В любое время",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "47aa6c39-f084-4ffa-a031-a52d480c7ca7",
            ref: "price",
            title: "Сколько вы готовы платить за сессию?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 10,
            choices: [
                {
                    id: "90c831e2-2301-466c-8916-240c3c2f8718",
                    title: "До 3500",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "e5a943c3-d5de-4604-a09c-53627bf8615a",
                    title: "3500-5000",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "dd0c70d3-a7ca-4fbd-9443-eac94cf0c9d5",
                    title: "От 5000",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "3029a07d-0e8e-4380-a59a-d15ba74f6f28",
                    title: "Цена неважна",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
    ],
} as SurveyQuestions

export const INDIVIDUAL_QUESTIONS = {
    title: "Индивидуальная анкета",
    subtitle: "",
    image: null,
    slug: "individual",
    is_primary: false,
    questions: [
        {
            id: "cc733c92-6853-45f6-8e49-bec741188ebb",
            ref: "has_been_before",
            title: "Вы впервые обращаетесь к психологу?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 1,
            choices: [
                {
                    id: "a41f020c-2d4d-433f-b1d3-979f1043fae0",
                    title: "Да",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "aca531ae-e7ba-40c3-9d0c-fbfb5d8ca6c2",
                    title: "Нет",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "9626bf79-2f97-4c0c-9aae-de080adab7df",
            ref: "sex",
            title: "Какого вы пола?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 2,
            choices: [
                {
                    id: "69261bc2-4a71-4de7-bc8b-1beb0d9320ac",
                    title: "Женского",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "a82c1e87-66b2-44a6-bb4b-76449a53270c",
                    title: "Мужского",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "7217d7d2-6f24-4bf5-942d-3e4cf15982c1",
                    title: "Не хочу отвечать",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "01b96a66-733e-47fa-abbd-3011ea911cb2",
            ref: "age",
            title: "Сколько вам лет?",
            type: "number",
            required: false,
            validations: {
                max_value: 100,
                min_value: 18,
            },
            step: 1,
            sequence_number: 3,
            choices: [],
            visibility_conditions: [],
        },
        {
            id: "7019f6a5-2771-4971-8825-bdd51d2a12b3",
            ref: "reported_problems",
            title: "Над чем вы хотите поработать?",
            type: "choices",
            required: true,
            validations: {},
            step: 2,
            sequence_number: 4,
            choices: [
                {
                    id: "a5e24f10-dae7-4e5b-bfe0-23f83bf83840",
                    title: "Мое состояние",
                    comment: null,
                    ref: null,
                    image: null,
                    choices: [
                        {
                            id: "a03345ac-96b3-4bbe-bc2d-be2943446578",
                            title: "У меня проблемы с самооценкой",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "566d8687-8fb6-45c2-b5f8-2486d147bcd2",
                            title: "Мне сложно справляться",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "d9117f52-3839-4641-a470-7de16f437d8b",
                            title: "Я чувствую эмоциональное",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "4bd92013-31c5-4f87-b9c5-7148993aea1c",
                            title: "Меня беспокоят страхи",
                            comment: null,
                            image: null,
                        },
                    ],
                },
                {
                    id: "59a7546d-ca9f-46c9-a033-bb9d3bf2b86f",
                    title: "Отношения",
                    comment: null,
                    ref: null,
                    image: null,
                    choices: [
                        {
                            id: "11804b64-1b8c-4606-a3eb-8ba56cadfe2c",
                            title: "Я чувствую одиночество",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "9e65861e-41bf-4b1e-95eb-ea32c7815ad2",
                            title: "Меня беспокоят отношения",
                            comment: null,
                            image: null,
                        },
                    ],
                },
                {
                    id: "3e845e46-5804-4f4b-b1c3-296931fb5bd1",
                    title: "Работа, карьера, учеба",
                    comment: null,
                    ref: null,
                    image: null,
                    choices: [
                        {
                            id: "4eb8bd82-bb8b-4132-9086-a9edafd8f8eb",
                            title: "Я не могу принять важное решение",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "af90e67e-73f0-49ef-aec3-5b986527fe9d",
                            title: "Я хочу поработать",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "b3dd6ebb-a857-483d-bf09-418e5f8dc9e8",
                            title: "Я часто прокрастинирую",
                            comment: null,
                            image: null,
                        },
                    ],
                },
                {
                    id: "4c91aba0-1c11-4824-98a0-c64e6f409bce",
                    title: "Мое самоопределение",
                    comment: null,
                    ref: null,
                    image: null,
                    choices: [
                        {
                            id: "8f17ffe7-f91c-4b7f-bb8d-192fe68f5692",
                            title: "Я не могу понять",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "d2cc542f-173c-43f2-8115-0137188ce7ab",
                            title: "Я хочу развить свои навыки",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "4f058a54-a084-450f-9cd4-34acffcecb26",
                            title: "Я хочу найти смысл жизни",
                            comment: null,
                            image: null,
                        },
                        {
                            id: "c185d6f0-33d3-462d-8fd7-40e30b315ed3",
                            title: "У меня вопросы сексуального",
                            comment: null,
                            image: null,
                        },
                    ],
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "93646898-875e-4073-91d1-e300449536f5",
            ref: "psychiatry",
            title: "Наблюдаетесь ли вы у психиатра?",
            type: "choice",
            required: true,
            validations: {},
            step: 2,
            sequence_number: 5,
            choices: [
                {
                    id: "6c3c5f37-8cb9-4b80-a50e-55ac0d6f913f",
                    title: "Да",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "31967b1d-1af8-4318-8733-6ad9575e207b",
                    title: "Нет",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "b51906d5-ebc7-46e2-a36f-be6f30f5a571",
                    title: "Наблюдалась раньше",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "10d44ccd-cd8d-4edf-8711-174b8a2bc3f5",
            ref: "form_of_work",
            title: "Как вы хотите работать с психологом?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 6,
            choices: [
                {
                    id: "96bacd34-d5e1-41f0-ab7b-e997155da3aa",
                    title: "Только онлайн",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "f25e1c8d-e018-4e9c-8e3d-77f9bd8af66b",
                    title: "Только лично",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "dc4d0b5a-6bef-4141-b28b-70c2ce62c7bb",
                    title: "Не принципиально",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "eac4e114-cb83-4542-955b-b3a0d83ad014",
            ref: "city",
            title: "В каком городе вам нужен психолог?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 7,
            choices: [
                {
                    id: "9ca1ec8d-2bb6-4184-99d8-ddee8f6cb510",
                    title: "Москва",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "0f54b716-e655-4939-bb26-093fcff482d2",
                    title: "Питер",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "47aa6c39-f084-4ffa-a031-a52d480c7ca7",
                    title: "Другой",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [
                {
                    question_id: "eac4e114-cb83-4542-955b-b3a0d83ad014",
                    precondition_question_id: "10d44ccd-cd8d-4edf-8711-174b8a2bc3f5",
                    operator: "equals",
                    value: "f25e1c8d-e018-4e9c-8e3d-77f9bd8af66b",
                },
            ],
        },
        {
            id: "90c831e2-2301-466c-8916-240c3c2f8718",
            ref: "daytime",
            title: "Когда вам удобно проводить сессии?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 8,
            choices: [
                {
                    id: "e5a943c3-d5de-4604-a09c-53627bf8615a",
                    title: "Утром",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "dd0c70d3-a7ca-4fbd-9443-eac94cf0c9d5",
                    title: "Днем",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "3029a07d-0e8e-4380-a59a-d15ba74f6f28",
                    title: "Вечером",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "860755d2-532d-49fa-bdf2-b38055442774",
                    title: "В любое время",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "fc714790-06c8-4194-99af-22053708c492",
            ref: "price",
            title: "Сколько вы готовы платить за сессию?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 9,
            choices: [
                {
                    id: "fd87367c-67c6-46f1-8aaa-2345d41ce377",
                    title: "До 3500",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "f137186a-a1a9-4205-8615-bd5342e61a7e",
                    title: "3500-5000",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "37a4469d-0b6b-4fb0-82b7-56031f8f75ff",
                    title: "От 5000",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "8efaa3d6-5388-4204-b4d8-388b3a89068e",
                    title: "Цена неважна",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "c08d74da-7fca-4d76-9310-329e1c527c7f",
            ref: "happy",
            title: "Довольны ли вы анкетой?",
            type: "yes_no",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 10,
            choices: [],
            visibility_conditions: [],
        },
    ],
} as SurveyQuestions

export const CHILD_QUESTIONS = {
    title: "Детская анкета",
    subtitle: "",
    image: null,
    slug: "child",
    is_primary: false,
    questions: [
        {
            id: "cc733c92-6853-45f6-8e49-bec741188ebb",
            ref: "has_been_before",
            title: "Вы впервые обращаетесь к психологу?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 1,
            choices: [
                {
                    id: "a41f020c-2d4d-433f-b1d3-979f1043fae0",
                    title: "Да",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "aca531ae-e7ba-40c3-9d0c-fbfb5d8ca6c2",
                    title: "Нет",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "9626bf79-2f97-4c0c-9aae-de080adab7df",
            ref: "name",
            title: "Как зовут ребенка?",
            type: "short_text",
            required: true,
            validations: {
                max_length: 255,
                min_length: 1,
            },
            step: 1,
            sequence_number: 2,
            choices: [],
            visibility_conditions: [],
        },
        {
            id: "69261bc2-4a71-4de7-bc8b-1beb0d9320ac",
            ref: "sex",
            title: "Какого пола ребенок?",
            type: "choice",
            required: true,
            validations: {},
            step: 1,
            sequence_number: 3,
            choices: [
                {
                    id: "a82c1e87-66b2-44a6-bb4b-76449a53270c",
                    title: "Женского",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "7217d7d2-6f24-4bf5-942d-3e4cf15982c1",
                    title: "Мужского",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "01b96a66-733e-47fa-abbd-3011ea911cb2",
            ref: "age",
            title: "Сколько лет ребенку?",
            type: "choice",
            required: false,
            validations: {},
            step: 1,
            sequence_number: 4,
            choices: [
                {
                    id: "7019f6a5-2771-4971-8825-bdd51d2a12b3",
                    title: "3-10",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "a5e24f10-dae7-4e5b-bfe0-23f83bf83840",
                    title: "11-15",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "a03345ac-96b3-4bbe-bc2d-be2943446578",
                    title: "16-18",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "566d8687-8fb6-45c2-b5f8-2486d147bcd2",
            ref: "reported_problems",
            title: "Над чем вы хотите поработать?",
            type: "choices",
            required: true,
            validations: {},
            step: 2,
            sequence_number: 5,
            choices: [
                {
                    id: "d9117f52-3839-4641-a470-7de16f437d8b",
                    title: "Поведение ребенка",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "4bd92013-31c5-4f87-b9c5-7148993aea1c",
                    title: "Тревожность",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "59a7546d-ca9f-46c9-a033-bb9d3bf2b86f",
                    title: "Проблемы в обучении",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "11804b64-1b8c-4606-a3eb-8ba56cadfe2c",
                    title: "Буллинг",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "9e65861e-41bf-4b1e-95eb-ea32c7815ad2",
                    title: "В отношениях произошла измена",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "3e845e46-5804-4f4b-b1c3-296931fb5bd1",
                    title: "Профориентация",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "4eb8bd82-bb8b-4132-9086-a9edafd8f8eb",
                    title: "Проблемы со сном",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "af90e67e-73f0-49ef-aec3-5b986527fe9d",
            ref: "psychiatry",
            title: "Наблюдается ли ребенок у этих специалистов?",
            type: "choices",
            required: true,
            validations: {},
            step: 2,
            sequence_number: 6,
            choices: [
                {
                    id: "b3dd6ebb-a857-483d-bf09-418e5f8dc9e8",
                    title: "Психиатр",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "4c91aba0-1c11-4824-98a0-c64e6f409bce",
                    title: "Психолог",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "8f17ffe7-f91c-4b7f-bb8d-192fe68f5692",
                    title: "Невролог",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "d2cc542f-173c-43f2-8115-0137188ce7ab",
                    title: "Эндокринолог",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "4f058a54-a084-450f-9cd4-34acffcecb26",
                    title: "Сомнолог",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "c185d6f0-33d3-462d-8fd7-40e30b315ed3",
                    title: "Не наблюдается",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "93646898-875e-4073-91d1-e300449536f5",
            ref: "form_of_work",
            title: "Как вы хотите работать с психологом?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 7,
            choices: [
                {
                    id: "6c3c5f37-8cb9-4b80-a50e-55ac0d6f913f",
                    title: "Только онлайн",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "31967b1d-1af8-4318-8733-6ad9575e207b",
                    title: "Только лично",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "b51906d5-ebc7-46e2-a36f-be6f30f5a571",
                    title: "Не принципиально",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "10d44ccd-cd8d-4edf-8711-174b8a2bc3f5",
            ref: "city",
            title: "В каком городе вам нужен психолог?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 8,
            choices: [
                {
                    id: "96bacd34-d5e1-41f0-ab7b-e997155da3aa",
                    title: "Москва",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "f25e1c8d-e018-4e9c-8e3d-77f9bd8af66b",
                    title: "Питер",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "dc4d0b5a-6bef-4141-b28b-70c2ce62c7bb",
                    title: "Другой",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "eac4e114-cb83-4542-955b-b3a0d83ad014",
            ref: "daytime",
            title: "Когда вам удобно проводить сессии?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 9,
            choices: [
                {
                    id: "9ca1ec8d-2bb6-4184-99d8-ddee8f6cb510",
                    title: "Утром",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "0f54b716-e655-4939-bb26-093fcff482d2",
                    title: "Днем",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "47aa6c39-f084-4ffa-a031-a52d480c7ca7",
                    title: "Вечером",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "90c831e2-2301-466c-8916-240c3c2f8718",
                    title: "В любое время",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
        {
            id: "e5a943c3-d5de-4604-a09c-53627bf8615a",
            ref: "price",
            title: "Сколько вы готовы платить за сессию?",
            type: "choice",
            required: true,
            validations: {},
            step: 3,
            sequence_number: 10,
            choices: [
                {
                    id: "dd0c70d3-a7ca-4fbd-9443-eac94cf0c9d5",
                    title: "До 3500",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "3029a07d-0e8e-4380-a59a-d15ba74f6f28",
                    title: "3500-5000",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "860755d2-532d-49fa-bdf2-b38055442774",
                    title: "От 5000",
                    comment: null,
                    ref: null,
                    image: null,
                },
                {
                    id: "fc714790-06c8-4194-99af-22053708c492",
                    title: "Цена неважна",
                    comment: null,
                    ref: null,
                    image: null,
                },
            ],
            visibility_conditions: [],
        },
    ],
} as SurveyQuestions

export const QUESTIONS = {
    "/api/survey/family": FAMILY_QUESTIONS,
    "/api/survey/individual": INDIVIDUAL_QUESTIONS,
    "/api/survey/child": CHILD_QUESTIONS,
} as const

export type QUESTIONS_KEYS = keyof typeof QUESTIONS
